import React from 'react';
import { Tooltip } from 'react-tooltip';

const TagAvatar = ({ tag, size = '32px', fontSize = '12px' }) => {
    const getInitials = (name) => {
        if (!name) return '';
        const parts = name.trim().split(/\s+/);
        if (parts.length === 1) {
            return parts[0].substring(0, 2).toUpperCase();
        } else {
            return (parts[0][0] + parts[1][0]).toUpperCase();
        }
    };

    return (
        <>
            <div
                data-tooltip-id={`tag-tooltip-${tag.id}`}
                data-tooltip-content={tag.name}
                style={{
                    width: size,
                    height: size,
                    borderRadius: '50%',
                    backgroundColor: tag.color || '#ccc',
                    color: '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: fontSize,
                    fontWeight: 'bold',
                    cursor: 'default',
                    // border: '1px solid #fff', // Optional: border for better separation
                    flexShrink: 0
                }}
            >
                {getInitials(tag.name)}
            </div>
            <Tooltip id={`tag-tooltip-${tag.id}`} place="top" style={{ zIndex: 9999 }} />
        </>
    );
};

export default TagAvatar;
